// Shared Google Event structured-data builder — keeps /events (ItemList) and
// event detail pages emitting identical, warning-free schema.
const abs = (u) => (u && u.startsWith('/') ? `https://goleicestershire.com${u}` : u);

export const parseEventPrice = (price) => {
  const p = (price || '').toLowerCase().trim();
  if (!p) return null;
  if (p.includes('free')) return '0';
  const m = p.match(/£\s*(\d+(?:\.\d{1,2})?)/);
  return m ? m[1] : null;
};

export const buildEventSchema = (e) => {
  const url = `https://goleicestershire.com/events/${e.slug}`;
  const price = parseEventPrice(e.price);
  return {
    '@type': 'Event',
    name: e.title,
    description:
      e.summary ||
      (e.description || '').slice(0, 300) ||
      `${e.title} — an event in ${e.town || 'Leicestershire'} on GoLeicestershire's What's On calendar.`,
    startDate: e.start_date,
    endDate: e.end_date || e.start_date,
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
    url,
    ...(e.hero_image ? { image: abs(e.hero_image) } : {}),
    location: {
      '@type': 'Place',
      name: e.venue || e.town || 'Leicestershire',
      address: { '@type': 'PostalAddress', addressLocality: e.town || 'Leicestershire', addressCountry: 'GB' },
    },
    ...(price !== null
      ? { offers: { '@type': 'Offer', price, priceCurrency: 'GBP', availability: 'https://schema.org/InStock', validFrom: (e.created_at || e.start_date || '').slice(0, 10), url: e.url || url } }
      : {}),
    organizer: { '@type': 'Organization', name: e.venue || 'GoLeicestershire', url: 'https://goleicestershire.com' },
  };
};
